<div class="message" [ngClass]="{ 'align-right': currentUser }">
  <!-- <div class="img" [hidden]="currentUser">
        <p>{{user.charAt(0).toUpperCase()}}</p>
    </div> -->
  <div class="content">
    <p>{{ messageContent }}</p>
  </div>
</div>
